import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ColumnApi, ExplainApi, ProgressApi } from '../api';
import { ExerciseElement } from '../base';
import { num } from '../../i18n';
import { iso, uiDir } from '../../bidi-html';

// ---- Column -----------------------------------------------------------------

@customElement('li-column')
export class LiColumn extends ExerciseElement<typeof ColumnApi> {
  protected readonly api = ColumnApi;
  render() {
    const props = this.controller?.props;
    if (!props) return nothing;
    const children = Array.isArray(props.children) ? props.children : [];
    return html`${children.map((c) => this.renderNode(c))}`;
  }
}
export const Column = { ...ColumnApi, tagName: 'li-column' };

@customElement('li-explain')
export class LiExplain extends ExerciseElement<typeof ExplainApi> {
  protected readonly api = ExplainApi;
  render() {
    const p = this.controller?.props;
    if (!p) return nothing;
    return html`
      <div class="ex explain">
        ${p.title ? html`<div class="label" dir=${uiDir(p.title)}>${iso(p.title)}</div>` : nothing}
        ${p.ca ? html`<div class="big-ca" dir="auto">${p.ca}</div>` : nothing}
        <div class=${p.ca ? 'en' : ''} dir=${uiDir(p.text)}>${iso(p.text)}</div>
      </div>
    `;
  }
}
export const Explain = { ...ExplainApi, tagName: 'li-explain' };

// ---- Progress ---------------------------------------------------------------


@customElement('li-progress')
export class LiProgress extends ExerciseElement<typeof ProgressApi> {
  protected readonly api = ProgressApi;
  render() {
    const p = this.controller?.props;
    if (!p) return nothing;
    const pct = p.total > 0 ? Math.min(100, Math.round((p.done / p.total) * 100)) : 0;
    return html`
      <div class="progress">
        <span>${p.label ?? `${num(p.done)} / ${num(p.total)}`}</span>
        <div class="bar"><div style="width:${pct}%"></div></div>
      </div>
    `;
  }
}
export const Progress = { ...ProgressApi, tagName: 'li-progress' };
